import apiInstance from "./axios";
import { validate_coupon, remove_coupon } from "utils/services/api/schemas";

const couponApi = {
  validateCoupon: async (data) => {
    const response = await apiInstance.post(validate_coupon, data);
    return response;
  },

  removeCoupon: async (data) => {
    const response = await apiInstance.post(remove_coupon, data);
    return response;
  },
};

export default couponApi;
